import { render, staticRenderFns } from "./TermDetail.vue?vue&type=template&id=01120122"
import script from "./TermDetail.vue?vue&type=script&lang=js"
export * from "./TermDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports